import { __assign } from "tslib";
import i18next from 'i18next';
import createI18nConfig from './create-i18n-config';
export var DEFAULT_I18N_NS = 'translation';
export var initI18n = function (lng, localeData) {
    var _a, _b;
    i18next.init(__assign(__assign({}, createI18nConfig()), { resources: (_a = {}, _a[lng] = (_b = {}, _b[DEFAULT_I18N_NS] = localeData, _b), _a), lng: lng }));
    return i18next;
};
